import gql from 'graphql-tag';

export const getPersonalizedDiscountCode = gql`
  query sfFoGetPersonalizedDiscountCodeByClassroomId($classroomId: String!) {
    sfFoGetPersonalizedDiscountCodeByClassroomId(classroomId: $classroomId) {
      code
      expiredAt
      discount
      currency
      discountUnit
    }
  }
`;

export const generatePersonalizedDiscountCode = gql`
  mutation sfFoGeneratePersonalizedDiscountCode($classroomId: String) {
    sfFoGeneratePersonalizedDiscountCode(classroomId: $classroomId) {
      code
    }
  }
`;
